import { EmptyPolicyNumber, PolicyNumber, ValidPolicyNumber} from 'ApplicationEntry/models/EnteredPolicyNumber';
import {EmptyString, isNonEmptyString, NonEmptyString, StringUnion} from 'Core/models/EmptyString';
import * as I from 'immutable';
import {ToPartialMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

type GLTERMProps = {
    plan: StringUnion,
    premium: StringUnion,
    calculatedPremium: StringUnion;
    cwa: StringUnion,
    situsState: StringUnion,
    type: StringUnion,
    faceAmt: StringUnion,
    policyNumber: PolicyNumber,
    premiumType : StringUnion,
    priInsured : StringUnion,
    spouseInsured : StringUnion,
    autoIssueEligibility : boolean,
    replacement: boolean,    
    riderCodes : I.List<string>,
    riderAmounts : I.List<number>,
    commission : StringUnion,
    deathBenefit : StringUnion,
    adb : boolean,
    sbVolume: StringUnion,
    premiumWaiver : boolean, 
  }

  
export class InvalidNewYorkGLTERM {
    public readonly key = 'InvalidNewYorkGLTERM';
  
    constructor(
      public readonly plan: StringUnion,
      public readonly premium: StringUnion,
      public readonly calculatedPremium: StringUnion,
      public readonly cwa: StringUnion,
      public readonly situsState: StringUnion,
      public readonly type: StringUnion,
      public readonly faceAmt: StringUnion,
      public readonly policyNumber: PolicyNumber,
      public readonly premiumType : StringUnion,
      public readonly priInsured : StringUnion,
      public readonly spouseInsured : StringUnion,
      public readonly autoIssueEligibility : boolean,
      public readonly replacement: boolean,    
      public readonly riderCodes : I.List<string>,
      public readonly riderAmounts : I.List<number>,
      public readonly commission : StringUnion,
      public readonly deathBenefit : StringUnion,
      public readonly adb : boolean,
      public readonly sbVolume: StringUnion,
      public readonly premiumWaiver : boolean
  
    ) {}
  }

  
export class ValidNewYorkGLTERM {

    public static createApp({
        plan,
        premium,
        calculatedPremium,
        cwa,
        situsState,
        type,
        faceAmt,
        policyNumber,
        premiumType,
        priInsured,
        spouseInsured,
        autoIssueEligibility,
        replacement,
        riderCodes,
        riderAmounts,
        commission,
        deathBenefit,
        adb,
        sbVolume,
        premiumWaiver,
    }: GLTERMProps){
      return this.create(
        plan,
        premium,
        calculatedPremium,
        cwa,
        situsState,
        type,
        faceAmt,
        policyNumber,
        premiumType,
        priInsured,
        spouseInsured,
        autoIssueEligibility,
        replacement,
        riderCodes,
        riderAmounts,
        commission,
        deathBenefit,
        adb,
        sbVolume,
        premiumWaiver
      )
    }
  
    public static create(
        plan: StringUnion,
        premium: StringUnion,
        calculatedPremium: StringUnion,
        cwa: StringUnion,
        situsState: StringUnion,
        type: StringUnion,
        faceAmt: StringUnion,
        policyNumber: PolicyNumber,
        premiumType : StringUnion,
        priInsured : StringUnion,
        spouseInsured : StringUnion,
        autoIssueEligibility : boolean,
        replacement: boolean,    
        riderCodes : I.List<string>,
        riderAmounts : I.List<number>,
        commission : StringUnion,
        deathBenefit : StringUnion,
        adb : boolean,
        sbVolume: StringUnion,
        premiumWaiver : boolean

    ) {
      return isNonEmptyString(plan)  ?  
      new ValidNewYorkGLTERM(
        plan,
        premium,
        calculatedPremium,
        cwa,
        situsState,
        type,
        faceAmt,
        policyNumber,
        premiumType,
        priInsured,
        spouseInsured,
        autoIssueEligibility,
        replacement,
        riderCodes,
        riderAmounts,
        commission,
        deathBenefit,
        adb,
        sbVolume,
        premiumWaiver
  
      ) :
      new InvalidNewYorkGLTERM(
        plan,
        premium,
        calculatedPremium,
        cwa,
        situsState,
        type,
        faceAmt,
        policyNumber,
        premiumType,
        priInsured,
        spouseInsured,
        autoIssueEligibility,
        replacement,
        riderCodes,
        riderAmounts,
        commission,
        deathBenefit,
        adb,
        sbVolume,
        premiumWaiver
      )
    }
  
  
    public readonly key = 'ValidNewYorkGLTERM';
    constructor(
        public readonly plan: StringUnion,
        public readonly premium: StringUnion,
        public readonly calculatedPremium: StringUnion,
        public readonly cwa: StringUnion,
        public readonly situsState: StringUnion,
        public readonly type: StringUnion,
        public readonly faceAmt: StringUnion,
        public readonly policyNumber: PolicyNumber,
        public readonly premiumType : StringUnion,
        public readonly priInsured : StringUnion,
        public readonly spouseInsured : StringUnion,
        public readonly autoIssueEligibility : boolean,
        public readonly replacement: boolean,    
        public readonly riderCodes : I.List<string>,
        public readonly riderAmounts : I.List<number>,
        public readonly commission : StringUnion,
        public readonly deathBenefit : StringUnion,
        public readonly adb : boolean,
        public readonly sbVolume: StringUnion,
        public readonly premiumWaiver : boolean
  
    ) {}
  }
  
  
export type NewYorkGLTERM = InvalidNewYorkGLTERM | ValidNewYorkGLTERM;

export type NewYorkGLTERMOptions<TReturn> = ToPartialMatchOptions<NewYorkGLTERM, 'key', TReturn>;

export const matchNewYorkGLTERM = <TReturn>(options: NewYorkGLTERMOptions<TReturn>) => (app: NewYorkGLTERM): TReturn => {
  switch (app.key) {
    case 'InvalidNewYorkGLTERM':
      return options.InvalidNewYorkGLTERM ? options.InvalidNewYorkGLTERM(app) : options.default(app);
    case 'ValidNewYorkGLTERM':
      return options.ValidNewYorkGLTERM ? options.ValidNewYorkGLTERM(app) : options.default(app);
  }
};

export const EmptyNewYorkGLTERM = new InvalidNewYorkGLTERM(
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  EmptyPolicyNumber,
  new EmptyString(),
  new EmptyString(),
  new EmptyString(),
  false,
  false,
  I.List<string>(),
  I.List<number>(),
  new EmptyString(),
  new EmptyString(),
  false,
  new EmptyString(),
  false
);

export const changePlan = (plan : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, plan : NonEmptyString.create(plan), riderCodes: I.List<string>(), riderAmounts : I.List<number>()});
export const changePremium = (premium : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, premium : NonEmptyString.create(premium)});
    export const changeCalculatedPremium = (calculatedPremium: string) => (app: NewYorkGLTERM) =>
    ValidNewYorkGLTERM.createApp({...app, calculatedPremium: NonEmptyString.create(calculatedPremium)});
export const changeCWA = (cwa : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, cwa : NonEmptyString.create(cwa)});
export const changeSitusState = (situsState : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, situsState: NonEmptyString.create(situsState)});
export const changeType = (type : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, type : NonEmptyString.create(type)});
export const changeFaceAmt = (faceAmt : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, faceAmt : NonEmptyString.create(faceAmt)});
export const changePolicyNumber = (polNum : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, policyNumber : ValidPolicyNumber.create(NonEmptyString.create(polNum))});
export const changePremiumType = (preType : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, premiumType : NonEmptyString.create(preType)});
export const changePriInsured = (priInsured : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, priInsured : NonEmptyString.create(priInsured)});
export const changeSpouseInsured = (spouseInsured : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, spouseInsured : NonEmptyString.create(spouseInsured)});
export const changeAutoIssue = (autoIssueEligibility : boolean) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, autoIssueEligibility });
export const changeReplacement = (replacement : boolean) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, replacement});
export const changeCommision = (commission : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, commission : NonEmptyString.create(commission)}); 
export const changeDeathBenefit = (deathBenefit : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, deathBenefit : NonEmptyString.create(deathBenefit)});
export const changeSBVolume = (vol : string) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, sbVolume : NonEmptyString.create(vol)});
export const changeADB = (adb : boolean) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, adb});
export const changeWaiver = (premiumWaiver : boolean) => (app : NewYorkGLTERM) => 
    ValidNewYorkGLTERM.createApp({...app, premiumWaiver});



export const changeRiderCodes = (riderCode: string, index : number) => (app : NewYorkGLTERM) => 
{
    const existingList: I.List<string> = app.riderCodes;
    const newList = existingList.set(index, riderCode);
    return ValidNewYorkGLTERM.createApp({...app, riderCodes:newList});
}

export const changeRiderAmount = (riderAmt: number, index : number) => (app : NewYorkGLTERM) => 
{
    const existingList: I.List<number> = app.riderAmounts;
    const newList = existingList.set(index, riderAmt);
    
    return ValidNewYorkGLTERM.createApp({...app, riderAmounts:newList});
}
